export class MainMenuToolbarObject {
    public menuStructuur: Array<MainMenu> = [];
}

export class MainMenu {
    public id: number;
    public id_menu: number;
    public name: string;
    public translate_property: string;
    public tooltop: string;
    public component_name: string;
    public deleted: boolean;
    public id_applicatie: number;
    public children: Array<MainMenu>;
    public icon: string;
    public payload: string;
    public id_container_name: string;
    public rights: string;
}
